export interface ProfileState {
  firstName: string | null;
  lastName: string | null;
  phone: string;
  email: string;
  isActive: boolean;
  pk: string;
}

export interface UserState {
  data?: ProfileState | null;
  loading?: boolean;
  error?: string | null;
}

export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAILURE = 'GET_USER_FAILURE';

export const UPDATE_PASSWORD_REQUEST = 'UPDATE_PASSWORD_REQUEST';
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS';
export const UPDATE_PASSWORD_FAILURE = 'UPDATE_PASSWORD_FAILURE';
